export const UPDATE_PARKING_MARKER_ID = 'UPDATE_PARKING_MARKER_ID'

export function parkingMarkerIdReducer (state = [], action) {
    switch (action.type){
        case UPDATE_PARKING_MARKER_ID:
            return action.payload
        default: return state
    }
}